import React, { useState } from 'react';

import PhotoModal from '../modals/PhotoModal'

import '../CommonHomeRouteStyles.css'

export default function FeaturedProjects() {

    const [photoModal, photoModalOpened] = useState(false);
    const [photo, photoSelected] = useState();

    const [featuredProjects] = useState([
        {
            name: 'the-underground',
            category: 'featured',
            description: "the-underground was our third team project in the bootcamp. You can post your shows so that people kind find your live performances. This one is also a MERN Stack using Apollo server and GraphQl",
            application: true,
            link: "https://castro-the-underground.herokuapp.com/"
        },
        {
            name: 'SECRET SHOW',
            category: 'featured',
            description: "SECRET SHOW was our second team project in the bootcamp. You can post your shows so that people kind find your live performances. This one is also a SQL and sequalize with RESTful APIs and handlebars",
            application: true,
            link: "https://castroolympias-secret-show.herokuapp.com/"
        },
        {
            name: 'we - Go!',
            category: 'featured',
            description: "we - Go! is a toursim app. Here is a first look",
            application: true,
            link: "https://castroolympias.github.io/Best-Tours/"
        },
        {
            name: 'Weather Dashboard',
            category: 'featured',
            description: "Weather Dashboard can fetch alot of city weather and forecast data.",
            application: true,
            link: "https://castroolympias.github.io/WeatherApp/"
        },
        {
            name: 'Chassis Calculator',
            category: 'featured',
            description: "I created this chassis calculator to make billing chassis/container equipment a lot easier. I created this on my free time so it is mine. It can calculate up to 13 different charges, with prebuilt selling rates, buy rates from trucking companies and ocean carriers. It can even be used to audit vender invoices while improving revenue recognition due to billing by recieved EDI data versus billing late in the game from late vender bills, thus improving PNB.",
            application: false,
            link: "https://raw.githubusercontent.com/CastroOlympias/react-portfolio/main/src/assets/images/featured/large-size/4.jpg"
        },
        {
            name: 'My Second Portfolio',
            category: 'featured',
            description: "This is my second version of my portfolio. This is just a simple HTML and CSS portfolio.",
            application: true,
            link: "https://castroolympias.github.io/My-New-Portfolio/"
        },
        {
            name: 'My Fist Portfolio',
            category: 'featured',
            description: "This is my first version of my portfolio. This is just a simple HTML and CSS portfolio.",
            application: true,
            link: "https://castroolympias.github.io/OrderOfTheHorns/"
        },
    ])

    const openPhotoModal = (image, i) => {
        const photoModalUnderlayer = document.getElementById('Photo-Modal-Underlayer')
        const photoModalImage = document.getElementById('Photo-Modal-Image')
        if (photoModal === false) {
            photoSelected({ ...image, index: i })
            photoModalOpened(!photoModal);
        } else {
            photoModalUnderlayer.className = 'Photo-Modal-Underlayer-Closed'
            photoModalImage.className = 'PhotoModal-Section-Position PhotoModal-Photo-Section-Dimensions-Closed'
            setTimeout(() => {
                photoModalOpened(!photoModal);
            }, 285);
        }
    }

    // const countrySearch = 'Germany'

    // fetch('https://www.triposo.com/api/20210317/location.json?part_of=' + countrySearch + '&account=6OIHILXY&token=cd6hxbcw7b7ujjuv48p0pjiqo5bb2zp3')

    //     .then(function (response) {
    //         return response.json();
    //     })

    //     .then(function (response) {
    //         console.log(countrySearch);
    //         console.log(response);
    //         console.log(response.results);
    //         console.log(countrySearch, ',', response.results[5].id);
    //     })


    // const searchTerm = 'Salt Lake City'


    // fetch('https://api.openweathermap.org/data/2.5/weather?q=' +
    //     searchTerm +
    //     '&units=imperial&exclude=hourly,minutely,alerts&appid=0372eaa7cde1ce19de6c28dd0eb2454c')

    //     .then(function(response) {
    //         return response.json();
    //     })

    //     .then(function(response) {
    //         console.log('Weather for', searchTerm)
    //         console.log(response)
    //     })




    // const options = {
    //     method: 'GET',
    //     headers: {
    //         'X-RapidAPI-Host': 'yh-finance.p.rapidapi.com',
    //         'X-RapidAPI-Key': '6dd61d9ca5msh44938a46d9d5c24p1096d2jsn272cdbd80e77'
    //     }
    // };

    // fetch('https://yh-finance.p.rapidapi.com/market/get-earnings?region=US&startDate=1585155600000&endDate=1589475600000&size=10', options)
    //     .then(response => response.json())
    //     .then(response => console.log(response))
    //     .catch(err => console.error(err));




    // https://rapidapi.com/apidojo/api/yh-finance
    // https://rapidapi.com/collection/stock-market-apis

    const directory = 'featured'

    return (

        <>
            {/* <div id="HomeRoute-Header" className='HomeRoute-Header-Title-Section-Dimensions HomeRoute-Header-Title-Section-Position'>
                <button id='Photo-Gallery-Header-Title' className='HomeRoute-Header-Color HomeRoute-Header-Animation-Open HomeRoute-Header-Spacing HomeRoute-Header-Dimensions HomeRoute-Header-Shape HomeRoute-Header-Position'>
                    <h1>Featured Projects</h1>
                </button>
            </div> */}

            {photoModal &&
                <>
                    <section onClick={openPhotoModal} id="Photo-Modal-Underlayer" className='Photo-Modal-Underlayer-Opened'>
                    </section>
                    <PhotoModal directory={directory} currentPhoto={photo} closePhotoModal={photoModalOpened} closeIt={openPhotoModal} />
                </>
            }

            <div className='Content-Section-Position Content-Section-Shape Content-Section-Color Content-Section-Dimesions'>

                {featuredProjects.map((image, i) => (

                    <img
                        className='Photos-Dimensions Photos-Shape'
                        id={featuredProjects[i].name}
                        src={require(`../../../../assets/images/${directory}/1440/${i}.jpg`)}
                        alt={image.name}
                        key={image.name}
                        onClick={() => openPhotoModal(image, i)}
                    />

                ))}
            </div>
        </>
    )
}

// work